/// <amd-module name="DistributedTaskUI/Logs/LogsTelemetryHelper" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";


export namespace LogsTelemetryProperties {
    // LogsTab properties
    export const downloadLogsClickSource = "downloadLogsClickSource";
}

const Feature_TaskStepComponentFeature: string = "taskStepComponent";
const Feature_ViewIssuesInPanel = "viewIssuesInPanel";

// Release propgress logs tab properties
const phaseIssuesErrorCount = "phaseIssuesErrorCount";
const phaseIssuesWarningCount = "phaseIssuesWarningCount";

export class LogsTelemetryHelper {
    public static publishDownloadLogsTelemetry(pageContext: IVssPageContext | undefined, source: string): void {
        if (!pageContext) {
            return;
        }

        const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        const eventProperties: { [key: string]: any } = {};
        eventProperties[LogsTelemetryProperties.downloadLogsClickSource] = source;
        telemetryService.publishEvent("DT-Logs-Temeletry-Area", Feature_TaskStepComponentFeature, eventProperties);
    }

    public static publishIssuesPanelTelemetry(pageContext: IVssPageContext | undefined, errors: string[], warnings: string[]): void {
        if (!pageContext) {
            return;
        }

        const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        const eventProperties: { [key: string]: any } = {};
        eventProperties[phaseIssuesErrorCount] = errors ? errors.length : 0;
        eventProperties[phaseIssuesWarningCount] = warnings ? warnings.length : 0;

        telemetryService.publishEvent("DT-Logs-Temeletry-Area", Feature_ViewIssuesInPanel, eventProperties);
    }
}
